/*
--------------------------------------------------------------------------------------------------------------
Autor:              EMANUEL GUIVAR
Fecha de creacion:  09/04/2025
Sistema:            Web seguros
Descripcion:        Encapsular seccion de formulario y titulo
BITACORA DE CAMBIOS 
--------------------------------------------------------------------------------------------------------------
CODIGO      REQ     ANALISTA                    FECHA       MOTIVO
--------------------------------------------------------------------------------------------------------------
*/
import React from 'react';

interface FormSectionProps {
    title: string,              // texto de label
    children: React.ReactNode,  // contenido
};

const FormSection = ({ title, children }:FormSectionProps) => {
    return (
        <div className="FormSection form-row mb-4">
            <div className="col-12">
                <h3 className="FormSection-title py-2 mb-3 font-italic">{title}</h3>
            </div>
            {children}
        </div>
    );
};

export default FormSection;